
<div class="background-video-img">
  <!-- video section start -->
  <!-- class="background-video"
  <video autoplay muted loop id="video-bg">
    <source src="assets/v-4-icone/videos/-dd65-44a7-b048-bd9de5358ecd.mp4" type="video/mp4" />
  </video>
  <div class="custom-overlay"></div> -->
  <!-- video section end -->
    <div *ngIf="!importedUser" class="card-adjustment">
    <div class="{{sectionFalg !== 'forgetPassword' ?'v4-login-card-2' : 'v4-login-card-3'}}">
      <div class="d-flex justify-content-center align-items-center flex-column h-available">
     <!-- <div #air id="air" class='air kenburns-top'></div> -->
     <div class="v4-login-card custom-width p-4 w-full lg:w-6 V4-Z-INDEX-1 card-mb-mob" style="overflow-y: auto;">
      <div class="d-flex justify-content-start w-100">
        <img class="login-logo-width" src="../../../assets/new-logo/SCBCLOGO-WHITE.svg" alt="loading">
      </div>

      <div [ngSwitch]="sectionFalg">
        <!-- Login Form -->
        <span *ngSwitchCase="'login'">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="text-start mb-5">
              <div class="color-grey v4-font-600 text-3x-l mb-3">
                {{ "sign in" | translator }}
              </div>
              <span class="color-grey v4-font-600 line-height-3 bottom-btns">
                {{ "Don't have an account?" | translator }}</span>
              <a class="v4-font-600 no-underline ml-2 v4-a cursor-pointer bottom-btns space-left" routerLink="/signup">{{
                "Create an account" | translator }}</a>
            </div>
            <!-- <div class="login-flex">
              <h1 class="main-heading V4-Z-INDEX-1 text-mt-mob">
                 {{ "Knowledge gate" | translator }}
               </h1>
               <p class="mini-heading V4-Z-INDEX-1">
                 {{ "Training" | translator }} | {{ "Knowledge" | translator }} |
                 {{ "Development" | translator }}
               </p>
            </div>  -->
          </div>
          <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <div>
              <section *ngIf="!newBrowser">
                <label for="email1" class="block text-900 font-medium mb-2 ms-label-view">{{
                  "E-mail" | translator
                  }}</label>
                <input dir="rtl" id="email1" type="text" formControlName="email" appNoInputSpace
                  placeholder="{{ 'E-mail' | translator }}" pInputText class="w-full mb-3 ms-input-view"
                  style="text-align: end !important;" dir="ltr" />
                <div *ngIf="
                    loginForm.get('email')?.invalid &&
                    (loginForm.get('email')?.dirty ||
                      loginForm.get('email')?.touched)
                  "></div>

                <label for="password1" class="block text-900 font-medium mb-2 ms-label-view">{{ "password" | translator
                  }}</label>
                <span class="p-input-icon-left w-100">
                  <i class="pi px-1 color-grey" [ngClass]="hidePassword ? 'pi-eye' : 'pi-eye-slash'" style="margin-top: -1rem;"
                    (click)="hidePassword =!hidePassword"></i>
                  <input id="password1" [type]="hidePassword ? 'password' : 'text'" formControlName="password"
                    placeholder="{{ 'password' | translator }}" appNoInputSpace pInputText
                    class="w-full mb-3 ms-input-view" style="text-align: end !important;" dir="ltr" 
                    (blur)="trimPasswordField('password')" />
                </span>

              </section>

              <section *ngIf="newBrowser">
                <label for="otp" class="block font-medium mb-2 color-grey">{{
                  "One-time password" | translator
                  }}</label>
                <!-- <input id="otp" type="text"  placeholder="( {{ 'OTP' | translator }} )" pInputText
                  class="w-full mb-3 ms-border ms-input-view" /> -->
                <ng-otp-input class="m-2" (onInputChange)="onOtpChange($event)"
                  [config]="{length:4, allowNumbersOnly : true}"></ng-otp-input>
                <!-- <div class="card flex justify-content-center">
                    <p-inputOtp [(ngModel)]="value" />
                </div> -->
              </section>

              <div class="flex align-items-right justify-content-between flex-column mb-4">
                <a (click)="sectionFalg = 'forgetPassword'"
                  class="font-medium no-underline ml-2 v4-a text-right cursor-pointer mb-2 font-bold">{{ "Forgot your password ?"
                  | translator }}
                </a>
                <div class="d-flex flex-column align-items-start justify-content-start gap-2">
                  <re-captcha id="recaptcha" formControlName="recaptcha" dark-theme="dark"
                    [class.is-invalid]="loginForm.get('recaptcha')?.invalid && (loginForm.get('recaptcha')?.dirty || loginForm.get('recaptcha')?.touched)">
                  </re-captcha>
                  <div
                    *ngIf="loginForm.get('recaptcha')?.invalid && (loginForm.get('recaptcha')?.dirty || loginForm.get('recaptcha')?.touched)"
                    class="invalid-feedback">
                    <div *ngIf="loginForm.get('recaptcha')?.errors?.['required']">{{'are required'|translator}}</div>
                  </div>
                </div>

              </div>

              <p *ngIf="message" style="color: red" class="text-center error">
                {{ message | translator}}
              </p>

              <div *ngIf="blockAccount && allowSendMail" class="d-flex justify-content-center mb-4">
                <a style="cursor: pointer; color:blue; text-decoration: underline; font-size:14px;" (click)="resendEmail(); startCountdown()">{{'click here' | translator}}</a>
              </div>

              <div *ngIf="blockAccount && !allowSendMail" class="d-flex justify-content-center mb-4">
                <p style="color: red">{{'seconds remaining to send email again'}} {{countdown}} {{'seconds' | translator}} </p>

              </div>

              <div *ngIf="blockAccount && !allowSendMail" class="d-flex justify-content-center mb-4">

                <p style="color: red"> {{'we sent a verification code to your email' | translator}} : {{loginForm.get('email')?.value}}
                </p>
              </div>

              <button type="submit" pButton [loading]="loading" pRipple label="{{ 'nothing new' | translator }}"
                [disabled]="newBrowser && this.loginForm.get('otp')?.value == ''" icon="pi pi-user"
                class="w-full v4-login-btn"></button>
            </div>
          </form>
          <!-- Reacptcha here
          <re-captcha id="recaptcha" name="recaptcha" #recaptcha="ngModel" [(ngModel)]="token" required
            [class.is-invalid]="recaptcha.invalid && (recaptcha.dirty || recaptcha.touched)"></re-captcha>
          <div *ngIf="recaptcha.invalid && (recaptcha.dirty || recaptcha.touched)" class="invalid-feedback">
            <div *ngIf="recaptcha.errors?.['required']">This field is required.</div>
          </div> -->
        </span>

        <!-- Rest Password -->
        <span *ngSwitchCase="'resetPassword'">
          <h3 class="text-start pb-2 color-grey font-bold 999">
            {{ "Password Reset" | translator }}
          </h3>
          <form [formGroup]="resetPasswordForm" (ngSubmit)="resetPassword()" dir="rtl" [style.fontSize.px]="12">
            <div class="form-group clearfix" [ngClass]="{ 'has-error': submitted }">
              <label class="font-12 mb-2 text-900 font-medium ms-label-view">{{ "New Password" | translator }}</label>
              <div class="d-flex-item-center">
                <input dir="rtl" class="text-end" matInput [type]="hide ? 'password' : 'text'"
                  formControlName="password" [(ngModel)]="password1" placeholder="{{ 'New Password' | translator }}"
                  pInputText class="w-full mb-3 ms-border ms-input-view" 
                  (blur)="trimPasswordField('password')" />
                <div *ngIf="hide; else elseBlock">
                  <i (click)="hide = !hide" class="fa-regular fa-eye-slash color-grey font-1rem mx-2"></i>
                </div>
                <ng-template #elseBlock><i (click)="hide = !hide"
                    class="fa-regular fa-eye color-grey font-1rem mx-2"></i></ng-template>
              </div>
            </div>
            <div class="form-group clearfix" [ngClass]="{ 'has-error': submitted }">
              <label class="font-12 mb-2 text-900 font-medium ms-label-view">{{
                "Confirm the new password" | translator
                }}</label>
              <div class="d-flex-item-center">
                <input dir="rtl" class="text-end" matInput [type]="hide2 ? 'password' : 'text'"
                  formControlName="conformPassword" [(ngModel)]="password2"
                  placeholder="{{ 'Confirm the new password' | translator }}" pInputText
                  class="w-full mb-3 ms-border ms-input-view" 
                  (blur)="trimPasswordField('conformPassword')" />
                <div *ngIf="hide2; else elseBlock2">
                  <i (click)="hide2 = !hide2" class="fa-regular fa-eye-slash color-grey font-1rem mx-2"></i>
                </div>
                <ng-template #elseBlock2><i (click)="hide2 = !hide2"
                    class="fa-regular fa-eye color-grey font-1rem mx-2"></i></ng-template>
              </div>

              <div dir="rtl" class="row mb-2 text-end">
                <h6 class="text-center color-grey">
                  {{ "Password creation requirements" | translator }}
                </h6>
                <div class="col-4 text-start" [ngClass]="checkpassword() ? 'text-success' : 'text-danger'">
                  <i [hidden]="checkpassword()" class="fa fa-times-circle" aria-hidden="true"></i>
                  <i [hidden]="!checkpassword()" class="fa fa-check-circle" aria-hidden="true"></i>
                  {{ "Password match" | translator }}
                </div>

                <div class="col-4 text-start" [ngClass]="atleast8() ? 'text-success' : 'text-danger'">
                  <i [hidden]="atleast8()" class="fa fa-times-circle" aria-hidden="true"></i>
                  <i [hidden]="!atleast8()" class="fa fa-check-circle" aria-hidden="true"></i>
                  {{ "At least 8 characters" | translator }}
                </div>

                <div class="col-4 text-start" [ngClass]="atleastcapital() ? 'text-success' : 'text-danger'">
                  <i [hidden]="atleastcapital()" class="fa fa-times-circle" aria-hidden="true"></i>
                  <i [hidden]="!atleastcapital()" class="fa fa-check-circle" aria-hidden="true"></i>
                  {{ "One uppercase letter (at least)" | translator }}
                </div>

                <div class="col-4 text-start" [ngClass]="atleastsmall() ? 'text-success' : 'text-danger'">
                  <i [hidden]="atleastsmall()" class="fa fa-times-circle" aria-hidden="true"></i>
                  <i [hidden]="!atleastsmall()" class="fa fa-check-circle" aria-hidden="true"></i>
                  {{ "One lowercase letter (at least)" | translator }}
                </div>

                <div class="col-4 text-start" [ngClass]="atleastnumber() ? 'text-success' : 'text-danger'">
                  <i [hidden]="atleastnumber()" class="fa fa-times-circle" aria-hidden="true"></i>
                  <i [hidden]="!atleastnumber()" class="fa fa-check-circle" aria-hidden="true"></i>
                  {{ "One number (at least)" | translator }}
                </div>

                <div class="col-4 text-start" [ngClass]="atleastspecial() ? 'text-success' : 'text-danger'">
                  <i [hidden]="atleastspecial()" class="fa fa-times-circle" aria-hidden="true"></i>
                  <i [hidden]="!atleastspecial()" class="fa fa-check-circle" aria-hidden="true"></i>
                  {{ "One special code (at least)" | translator }}
                </div>
              </div>
            </div>
            <p *ngIf="message" style="color: red" class="text-center error">
              {{ message | translator}}
            </p>
            <div class="col-xs-12 form-group text-right">
              <button type="submit" pButton pRipple label="{{ 'agree on' | translator }}" icon="pi pi-key"
                class="w-full v4-login-btn"></button>
            </div>
          </form>
        </span>
        <span *ngSwitchCase="'forgetPassword'">
          <h5 class="text-start pb-2 color-grey font-bold">
            {{ "Forgot your password" | translator }}
          </h5>
          <form [formGroup]="forgotForm" (ngSubmit)="forgotPasword()" novalidate>
            <div>
              <label for="email" class="block text-900 font-medium mb-2 ms-label-view">{{ "E-mail" | translator
                }}</label>
              <input dir="rtl" id="email" type="text" formControlName="email" placeholder="{{ 'E-mail' | translator }}"
                pInputText class="w-full mb-3 ms-border ms-input-view" />
              <p *ngIf="message" style="color: red" class="text-center error">
                {{ message | translator }}
              </p>
              <div class="col-xs-12 form-group text-right">
                <button type="submit" pButton pRipple label="{{ 'agree on' | translator }}" icon="pi pi-key"
                  class="w-full v4-login-btn"></button>
              </div>
            </div>
          </form>
        </span>
      </div>
    </div>
    <p [hidden]="sectionFalg == 'login'" class="text-center pt-3 v4-color-white V4-Z-INDEX-1">
      <span class="white">{{ "do you have an account?" | translator }}</span>
      &nbsp;&nbsp;

      <span (click)="sectionFalg = 'login'" class="bottom-btns2">
        {{ "sign in" | translator }}
      </span>
    </p>
  </div>
</div>
</div>

  <!-- edit missing -->

  <div *ngIf="importedUser" class="d-flex justify-content-center align-items-center flex-column h-100vh banner">
    <!-- <div #air id="air" class='air kenburns-top'></div> -->
    <div #air id="air" class='air'></div>
    <h1 class="main-heading V4-Z-INDEX-1 mt-4">{{"Knowledge gate" | translator}}</h1>
    <p class="mini-heading V4-Z-INDEX-1"> {{"Knowledge" | translator}} | {{"Training" | translator}} | {{"Development" |
      translator}} </p>

    <div class="v4-login-card p-4 w-full lg:w-6 V4-Z-INDEX-1 my-4" style="max-height: 100vh; overflow: auto;">
      <div class="text-center mb-5">
        <img class="signup-logo" src="../../../assets/v-4-icone/Vector.png" alt="Image" height="50" class="mb-3">
        <h3 class="heading color-grey"> {{"Please fill in the missing details for your account" | translator}}</h3>

      </div>
      <app-signup-form [type]="'MISSING'" [data]="importedUserData"></app-signup-form>
    </div>
  </div>
</div>